<template>
            <v-card>
                <v-card-text class="text--primary">
                    <p>(menu in upper left corner)</p>
                </v-card-text>

                <v-card-text class="text--primary">
                    <p style="font-size: 1.5em">RedemptionDB.web.app is in active development, user data may not be saved.</p>
                </v-card-text>
                <p v-if="$store.getters.getIsUserLoggedIn">Display Name: {{ user.displayName }}</p>
                <p v-if="$store.getters.getIsUserLoggedIn">Email: {{ user.email }}</p>
<!--                <p v-if="$store.getters.getIsUserLoggedIn">UID: {{ user.uid }}</p>-->
            </v-card>
</template>

<script>

    export default {
        name: 'Home',
        data() {
            return {
                drawer: false, // Hide mobile side menu by default
                users: []
            };
        },
        methods: {},
        computed: {
            cards() {
                return this.$store.getters.cards;
            },
            user() {
                return this.$store.getters.user;
            }
        }
    }
</script>
